// Karunna — Recently viewed products
// Guarda los productos vistos en localStorage y pinta sus tarjetas (krn-card)
// dentro del carrusel propio (krn-carousel) usando la Section Rendering API.

const STORAGE_KEY = 'krn-recently-viewed';
const MAX_STORED = 24;

class KrnRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const current = this.dataset.currentHandle || '';
    const limit = parseInt(this.dataset.limit || '8', 10);
    const cardSection = this.dataset.cardSection;
    const track = this.querySelector('[data-krn-track]');
    if (!track) return;

    let list = this.read();

    // Rastrear el producto actual (solo en páginas de producto).
    if (current) {
      list = list.filter((h) => h !== current);
      list.unshift(current);
      list = list.slice(0, MAX_STORED);
      this.write(list);
    }

    const toShow = list.filter((h) => h !== current).slice(0, limit);
    const designMode = window.Shopify && window.Shopify.designMode;

    if (toShow.length === 0) {
      if (designMode) {
        track.innerHTML =
          '<p style="opacity:.6;margin:0">Aquí aparecerán los productos que tus clientes ya vieron.</p>';
        this.hidden = false;
      }
      return;
    }

    const base = this.baseUrl();

    Promise.all(
      toShow.map((handle) =>
        fetch(base + 'products/' + encodeURIComponent(handle) + '?section_id=' + cardSection)
          .then((r) => (r.ok ? r.text() : ''))
          .catch(() => '')
      )
    ).then((cards) => {
      const html = cards
        .map((c) => (c || '').trim())
        .filter(Boolean)
        .join('');
      if (!html) return;
      track.innerHTML = html;
      this.hidden = false;
    });
  }

  read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage no disponible */
    }
  }

  baseUrl() {
    const root = this.dataset.rootUrl || '/';
    return root.endsWith('/') ? root : root + '/';
  }
}

if (!customElements.get('krn-recently-viewed')) {
  customElements.define('krn-recently-viewed', KrnRecentlyViewed);
}
